export enum JobFulfillmentType {
    None = 0,
    DefaultWorkflow = 1,
    AyaDirectLead = 4,
    ApplyWithAya = 5
}

export enum JobFulfillmentTypeNames {
    StandardApply = 'Standard Apply',
    ApplyWithAya = 'Apply With Aya',
    AyaLeads = 'Aya Leads'
}

export const enum JobFulfillmentTypeInfo {
    StandardApply = `Candidates click on "I'm Interested" in MyAya and submittal information is sent directly 
                     to the recruiter to vet prior to the candidate being submitted to the account manager.`,
    ApplyWithAya = `<p><strong>Permanent/CoreHire :</strong> Eligible candidates (matching profession & specialty or related specialty) who click "Apply w/ Aya" in MyAya 
                    will be prompted to provide additional submittal information, and a submittal packet will be sent directly to the account manager 
                    (bypassing the recruiter).</p>
                    <p><strong>Education Services :</strong> Candidates who click on "Apply with Aya" at School facilities will be prompted to provide additional 
                    submittal information which is sent directly to the recruiter to vet prior to the candidate being submitted to the account manager.</p>`,
    AyaLeads = 'Aya Leads candidates directly apply to jobs in MyAya and profiles are sent to the Facility without any vetting by Aya recruitment.'
}

export const JobFulfillmentTypes = [
    {
        id: JobFulfillmentType.DefaultWorkflow,
        name: JobFulfillmentTypeNames.StandardApply,
        info: JobFulfillmentTypeInfo.StandardApply
    },
    {
        id: JobFulfillmentType.AyaDirectLead,
        name: JobFulfillmentTypeNames.AyaLeads,
        info: JobFulfillmentTypeInfo.AyaLeads
    },
    {
        id: JobFulfillmentType.ApplyWithAya,
        name: JobFulfillmentTypeNames.ApplyWithAya,
        info: JobFulfillmentTypeInfo.ApplyWithAya
    }
];
